(function () {

    'use strict';

    angular.module('Services').factory('CarrierProfileZonesTableService', CarrierProfileZonesTableService);

    CarrierProfileZonesTableService.$inject = [
        'Carrier', 
        'TableLiteFactory', 
        'zonePostcodeTableService', 
        '$timeout', 
        '$uibModal', 
        'toastr', 
        'ConfirmationModalFactory'
    ];

    function CarrierProfileZonesTableService(
        Carrier, 
        TableLiteFactory, 
        zonePostcodeTableService, 
        $timeout, 
        $uibModal, 
        toastr, 
        ConfirmationModalFactory
    ) {
        return function (paramId, countries, carrierProfile) {
            const viewConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.deleteZone.MESSAGE',
                code: 'messages.warning.deleteZone.CODE',
            });
            let zoneTable = {
                optionAddOns: {
                    buttons: [
                        {
                        class: 'btn-primary',
                        label: 'ADD NEW ZONE',
                        onClick: function () {
                            angular.extend(carrierProfile.zoneDetails, {id: 'new'});
                            carrierProfile.zoneDetails.postcodesTable = null;
                            $timeout(() => {
                                carrierProfile.zoneDetails.postcodesTable =
                                    new zonePostcodeTableService(carrierProfile.zoneDetails, carrierProfile.id).tableData;
                            });
                        }
                    }, {
                        class: 'btn-success',
                        label: 'IMPORT ADDITIONAL ZONES/POSTCODE DATA',
                        onClick: function () {
                            var modalInstance = $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                windowClass: 'r-c-p-modal',
                                templateUrl: '/templates/pages/carriers/additionals/importZoneModal.html',
                                controller: function (carrierProfile, Upload, $timeout, $uibModalInstance) {
                                    let vm = this;
                                    vm.isColumnInvalid = isColumnInvalid;
                                    vm.importCSV = importCSV;
                                    vm.dismiss = dismiss;
                                    vm.validateFile = validateFile;
                                    vm.viewPendingImport = viewPendingImport;
                                    vm.downloadTemplate = downloadTemplate;
                                    vm.columnLabels = [{
                                        name: 'ZONE NAME',
                                        value: 'NAME'
                                    }, {
                                        name: 'ZONE CODE',
                                        value: 'CODE'
                                    }, {
                                        name: 'COUNTRY CODE',
                                        value: 'COUNTRYCODE'
                                    }, {
                                        name: 'POSTCODE',
                                        value: 'POSTCODE'
                                    }, {
                                        name: 'SUBURB',
                                        value: 'SUBURB'
                                    }];
                                    vm.columnValues = [
                                        {name: 'Column 1', value: 1, sampleVal: 'Melbourne AU'},
                                        {name: 'Column 2', value: 2, sampleVal: 'MEL'},
                                        {name: 'Column 3', value: 3, sampleVal: 'AU'},
                                        {name: 'Column 4', value: 4, sampleVal: '3001'},
                                        {name: 'Column 5', value: 5, sampleVal: 'Melbourne'}
                                    ];
                                    vm.columns = [...vm.columnValues.map((val, index)=>{
                                        return {value: angular.extend(angular.copy(val), {label: vm.columnLabels[index]})};
                                    })];
                                    vm.columnsRaw = angular.copy(vm.columns);
                                    init();

                                    function init() {
                                        checkForDraft();
                                    }
                                    function checkForDraft() {
                                        vm.draftSearching = true;
                                        Carrier.getZonePostcodeFileDetail(paramId,data=>{
                                            vm.hasDraft = !!angular.getObjVal(data, 'content.length');
                                            vm.draftSearching = false;
                                        },error=>{
                                            toastr.error('Unable to search for draft imports', error.message);
                                            vm.draftSearching = false;
                                        },{size:1,draft:true});
                                    }
                                    function isColumnInvalid(column) {
                                        if (!column) {
                                            return false;
                                        }
                                        return vm.columns.filter(col => {
                                            return column.value.value=== col.value.value;
                                        }).length > 1;
                                    }
                                    function dismiss() {
                                        $uibModalInstance.dismiss();
                                    }
                                    function importCSV(form) {
                                        form.$setSubmitted();
                                        if(form.$invalid){
                                            return false;
                                        }
                                        if(vm.file){
                                            vm.isImporting = true;
                                            Carrier.importZonePostcode(paramId, data=>{
                                                vm.isImporting = false;
                                                toastr.success('Import draft successfully created!');
                                                viewPendingImport();
                                            }, err =>{
                                                vm.isImporting = false;
                                                toastr.error('Creating import draft failed!', err.message);
                                            }, vm.file,evt=>{
                                                vm.progressData = 100.0 * evt.loaded / evt.total;
                                            });
                                        }
                                    }
                                    function viewPendingImport() {
                                        var modalInstance = $uibModal.open({
                                            animation: true,
                                            ariaLabelledBy: 'modal-title',
                                            ariaDescribedBy: 'modal-body',
                                            windowClass: 'full-height-modal',
                                            templateUrl: '/templates/pages/carriers/additionals/pendingImportsModal.html',
                                            controller: 'PendingImportModalController',
                                            controllerAs: 'vm',
                                            size: 'lg',
                                            resolve: {
                                                param: function () {
                                                    return {
                                                        paramId,
                                                        name: 'zoneImport',
                                                        countries
                                                    };
                                                },
                                                importService: function () {
                                                    //return Carrier.confirmImportAPI
                                                }
                                            }
                                        });
                                        modalInstance.result.then(function (data) {
                                            checkForDraft();
                                        }, function () {
                                            checkForDraft();
                                        });
                                    }
                                    function validateFile(file) {
                                        return file.type === 'text/csv' || file.type === 'application/vnd.ms-excel';
                                    }
                                    function getOrderedCol(field) {
                                        return vm.columns.map(column=>{
                                            return vm.columnsRaw[column.value.value - 1].value[field];
                                        });
                                    }
                                    function getMappedFields() {
                                        return getOrderedCol('label').map(col=>col.value).toString();
                                    }
                                    function getMappedValues() {
                                        return getOrderedCol('sampleVal').toString()
                                    }
                                    function downloadTemplate() {
                                        let headers = getMappedFields();
                                        let sampleBody = getMappedValues();
                                        download(headers + "\r\n" + sampleBody, "zone-import-template.csv", "text/csv");
                                    }
                                },
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    carrierProfile: function () {
                                        return carrierProfile;
                                    }
                                }
                            });
                            modalInstance.result.then(function (data) {
                                sendRequest({});
                            }, function () {
                                sendRequest({});
                            });
                        }
                    },{
                        class: 'btn-success',
                        label: 'EXPORT ZONES/POSTCODE DATA',
                        onClick: function () {
                            const vm =this;
                            let selected = zoneTable.data.filter(item=>{
                                return item.isSelected;
                            });
                            if(!selected.length){
                                toastr.warning('Please select postcodes to Export');
                                return;
                            }
                            vm.columnLabels = [{
                                name: 'ZONE NAME',
                                value: 'NAME'
                            }, {
                                name: 'ZONE CODE',
                                value: 'CODE'
                            }, {
                                name: 'COUNTRY CODE',
                                value: 'COUNTRYCODE'
                            }, {
                                name: 'POSTCODE',
                                value: 'POSTCODE'
                            }, {
                                name: 'SUBURB',
                                value: 'SUBURB'
                            }];
                            vm.columnValues=[
                                {name: 'Column 1', value: 1, sampleVal: 'Melbourne AU'},
                                {name: 'Column 2', value: 2, sampleVal: 'MEL'},
                                {name: 'Column 3', value: 3, sampleVal: 'AU'},
                                {name: 'Column 4', value: 4, sampleVal: '3001'},
                                {name: 'Column 5', value: 5, sampleVal: 'Melbourne'}
                            ]
                            vm.columns = [...vm.columnValues.map((val, index)=>{
                                return {value: angular.extend(angular.copy(val), {label: vm.columnLabels[index]})};
                            })];
                            vm.columnsRaw = angular.copy(vm.columns);
                            
                            let headers = getMappedFields();
                            let sampleBody = getMappedValues();
                            download(headers + "\r\n" + sampleBody, "zone-export.csv", "text/csv");

                            function getOrderedCol(field) {
                                return vm.columns.map(column=>{
                                    return vm.columnsRaw[column.value.value - 1].value[field];
                                });
                            }
                            function getMappedFields() {
                                return getOrderedCol('label').map(col=>col.value).toString();
                            }
                            function getMappedValues() {
                                let line ='';
                                for(let i =0; i < selected.length;i++){
                                    let str =''
                                    if(selected[i].postCodes){
                                        for(let x in selected[i].postCodes){
                                            str += `${selected[i].country.name},${selected[i].code},${selected[i].country.code},${selected[i].postCodes[x]} \r\n`;
                                        }
                                    }else{
                                        str = `${selected[i].country.name},${selected[i].code},${selected[i].country.code} \r\n`
                                    }
                                    line += str;
                                }
                                return line;
                            }
                        }
                    },{
                        class: 'btn-danger',
                        label: 'DELETE',
                        onClick: function () {
                            let selected = zoneTable.data.filter(item=>{
                                return item.isSelected;
                            });
                            if(!selected.length){
                                toastr.warning('Please select postcodes to Delete');
                                return;
                            }
                            const selectedIds =[]
                            const payload ={}
                            for(let x in selected){
                               selectedIds.push(selected[x].id)
                            }
                            payload.zoneIds = selectedIds

                            let zoneId = Object.keys(payload).map(key=>{
                                return `?${key}=${payload[key].toString()}`
                            }).join('&');
                            viewConfirmation.getInstance().result.then(cond=>{
                                if(!cond){return;}
                                Carrier.removeSelectedZonePostcode(carrierProfile.id,
                                    res=>{
                                        toastr.success('Selected Zone deleted');
                                        sendRequest({});
                                    },
                                    err=>{
                                        toastr.error(err.message,err.code);
                                    },zoneId)
                            })
                           
                            
                        }
                    }],
                    postcodeFilter: {
                        onSubmit: function () {
                            tableActions.sendRequest({
                                postCode: this.model || ''
                            })
                        }
                    },
                    wrapperClass: 'pull-right',
                    url: '/templates/pages/carriers/additionals/filterByPostcode.html'
                },
                config: {
                    noExtract: true,

                },
                headers: [{
                    label: 'SELECT',
                    class: 'text-center',
                    filter: {
                        type: 'checkbox'
                    }
                }, {
                    label: 'ZONE NAME',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'ZONE CODE',
                    viewName: 'code',
                    filterName: 'code',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'COUNTRY',
                    viewName: 'countryName',
                    filterName: 'country.code',
                    filter: {
                        type: 'select2',
                        viewName: 'name',
                        filterBy: 'code',
                        placeholder: 'Search',
                        class: 'table-input',
                        items: countries,
                        onSelect: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'ACTION',
                    viewName: 'action'
                }],
                data: [],
                rowOnClick: item => {
                    angular.extend(carrierProfile.zoneDetails, item);
                    carrierProfile.zoneDetails.postcodesTable = null;
                    $timeout(() => {
                        carrierProfile.zoneDetails.postcodesTable = new zonePostcodeTableService(carrierProfile.zoneDetails, carrierProfile.id).tableData;
                    });
                }
            };
            const tableActions = new TableLiteFactory(zoneTable,
                {
                    serviceCallback: Carrier.getZonePostcodeFileDetail,
                    callbackFormat: ['id', 'success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        draft: false
                    },
                    paramId: paramId
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row) {
                    row.action = {
                        type: 'button',
                        buttons: [{
                            text: 'delete',
                            class: 'btn btn-danger',
                            action: row => {
                                viewConfirmation.getInstance().result.then(cond=>{
                                    if(cond){
                                        Carrier.removeZoneProfile({carrierProfileId: paramId, zoneId: row.id}, data=>{
                                            toastr.success('Zone deleted');
                                            sendRequest({});
                                        }, err=>{
                                            toastr.error('Unabled to delete zone', err.message);
                                        })
                                    }
                                });
                            }
                        }]
                    };
                    row.countryName = angular.getObjVal(row, 'country.name');
                    zoneTable.data.push(row);
                })
            }

            this.tableData = zoneTable;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/CarrierProfileZonesTableService.js